module.exports = __webpack_public_path__ + "img/1.901c1d14.png";